import { Btn } from 'components/Btn'
import { CTA, CTAProps } from 'components/CTA'
import { Spinner } from 'components/Spinner'
import React, { ReactNode } from 'react'

export type SubmitBtnProps = {
	isSubmitting?: boolean
	disabled?: boolean
	children?: ReactNode
	className?: string
	ctaConfig?: Omit<CTAProps, 'children'>
}
export const SubmitBtn = ({
	children,
	isSubmitting,
	disabled,
	className,
	ctaConfig,
}: SubmitBtnProps) => {
	return (
		<CTA {...ctaConfig}>
			<Btn
				className={`submit-btn${className ? ` ${className}` : ''}`}
				noDefault={false}
				disabled={isSubmitting || disabled}
				type='submit'
			>
				{isSubmitting ? <Spinner height='full' /> : children || 'Save'}
			</Btn>
		</CTA>
	)
}
